import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Checkbox, 
  FormControlLabel,
  Paper,
  useTheme
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { stepOneStyles } from '../../styles/locationCampaign/stepOne';
import background from '../../assets/images/location_campaign/lemn.png';
import kozel from '../../assets/images/location_campaign/logo.png';
import premiu from '../../assets/images/location_campaign/premiu.png';
import despre_alcool from '../../assets/images/promo-despre-alcool.png';
import linie1 from '../../assets/images/location_campaign/linie1.png';
import linie2 from '../../assets/images/location_campaign/linie2.png';

interface StepOneProps {
  dataNasterii: Dayjs | null;
  onDateChange: (newDate: Dayjs | null) => void;
  onNext: () => void;
  errors: { [key: string]: string };
}

export default function StepOne({ dataNasterii, onDateChange, onNext, errors }: StepOneProps) {
  const theme = useTheme();
  const [agreed, setAgreed] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const handleDateFocus = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDatePickerOpen(true);
  };

  const handleDateChange = (newDate: Dayjs | null) => {
    onDateChange(newDate);
    setIsDatePickerOpen(false);
  };

  const handleNext = () => {
    if (!dataNasterii || !agreed || errors.dataNasterii) {
      return;
    }
    onNext();
  };

  return (
    <Box sx={stepOneStyles.container}>
      <Paper elevation={0} sx={stepOneStyles.paper(background)}>
          {/* Header */}
          <Box sx={stepOneStyles.header}>
            <Box
              component="img"
              src={kozel}
              alt="Kozel"
              sx={stepOneStyles.logo}
            />
          </Box>

          <Box sx={stepOneStyles.content}>
            {/* Main Title */}
            <Typography variant="h1" sx={stepOneStyles.mainTitle(theme)}>
              MEEEEEEREU ÎMPREUNĂ
            </Typography>
            
            <Typography variant="h4" sx={stepOneStyles.subtitle(theme)}>
              CÂȘTIGĂM PREMII
            </Typography>

            <Typography 
              variant="h5" 
              sx={{ 
                ...stepOneStyles.birthDateTitle, 
                fontWeight: 'bold' ,
                marginTop: '20px',
              }}
            >
              Mulțumim pentru participare! Campania s-a încheiat.
            </Typography>

            <Typography 
              variant="h6" 
              sx={{ 
                ...stepOneStyles.birthDateTitle, 
                fontStyle: 'italic' 
              }}
            >
              Lista câștigătorilor se va afișa după validarea finală.
            </Typography>

            {/* Instructions */}
            <Box sx={stepOneStyles.instructions}>
              <Typography variant="body1" sx={stepOneStyles.instructionsText}>
                {/* Cumpără oricare 2 produse Kozel, pe același bon fiscal, înscrie-te în campanie și ai șansa să câștigi, prin tragere la sorți, un voucher Emag!<br></br> */}
                Perioada: 04.08 - 04.10.2025
              </Typography>
            </Box>

            {/* Prize Section */}
            <Box sx={stepOneStyles.prizeSection}>
              <Typography variant="h6" sx={stepOneStyles.prizeTitle}>
                TOMBOLĂ LA FINAL DE CAMPANIE
              </Typography>
              
              <Box sx={stepOneStyles.prizeContent}>
                <Box sx={stepOneStyles.prizeLeftSection}>
                  <Box sx={stepOneStyles.prizeCircle}>
                    <Typography sx={stepOneStyles.prizeCircleNumber}>
                      60
                    </Typography>
                    <Typography sx={stepOneStyles.prizeCircleText}>
                      x
                    </Typography>
                  </Box>
                  <Typography sx={stepOneStyles.prizeAmount}>
                    Voucher Emag 500 lei
                  </Typography>
                </Box>
                
                <Box
                  component="img"
                  src={premiu}
                  alt="Premiu Emag 500 LEI"
                  sx={stepOneStyles.prizeImageInSection}
                />
              </Box>
            </Box>

            {/* Birth Date Section */}
            {/* <Typography variant="h6" sx={stepOneStyles.birthDateTitle}>
              Completează data nașterii
            </Typography> */}

            {/* Linia 1 - înainte de input */}
            {/* <Box sx={stepOneStyles.lineContainer}>
              <Box
                component="img"
                src={linie1}
                alt="Linia 1"
                sx={stepOneStyles.lineImage}
              />
            </Box> */}

            {/* <DatePicker
              value={dataNasterii}
              onAccept={handleDateChange}
              closeOnSelect={true}
              format="DD/MM/YYYY"
              open={isDatePickerOpen}
              onOpen={() => setIsDatePickerOpen(true)}
              onClose={() => setIsDatePickerOpen(false)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  placeholder: "ZZ LL AAAA",
                  onClick: handleDateFocus,
                  error: Boolean(errors.dataNasterii),
                  helperText: errors.dataNasterii,
                  sx: stepOneStyles.datePickerField
                }
              }}
            /> */}

            {/* Linia 2 - după input */}
            {/* <Box sx={stepOneStyles.lineContainer}>
              <Box
                component="img"
                src={linie2}
                alt="Linia 2"
                sx={stepOneStyles.lineImage}
              />
            </Box> */}

            {/* Agreement Checkbox */}
            {/* <FormControlLabel
              control={
                <Checkbox 
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  sx={stepOneStyles.checkbox}
                />
              }
              label={
                <Typography variant="body2" sx={{
                  ...stepOneStyles.checkboxLabel,
                  ...stepOneStyles.checkboxTextRules,
                }}>
                  Am citit integral și am înțeles prevederile
                  <a target={'_blank'} rel="noreferrer" href={`/pdf/2025/REGULAMENT__Kozel_Mereu impreuna castigam premii_4.08-4.10.pdf`}> Regulamentului Campaniei</a>
                </Typography>
              }
              sx={stepOneStyles.formControlLabel}
              /> */}

                {/* Continue Button */}
            {/* <Box sx={stepOneStyles.buttonContainer}>
              <Button
                variant="contained"
                disabled={!dataNasterii || !agreed || Boolean(errors.dataNasterii)}
                onClick={handleNext}
                sx={stepOneStyles.continueButton}
              >
                CONTINUĂ
              </Button>
            </Box> */}

            {/* Footer Info */}
            <Box sx={stepOneStyles.footer}>
              {/* <Typography variant="caption" sx={stepOneStyles.footerText}>
                Campania se desfășoară doar în locațiile selectate de organizator
              </Typography> */}
              
              <Box sx={stepOneStyles.footerImageContainer}>
                <Box
                  component="img"
                  src={despre_alcool}
                  alt="Despre alcool"
                  sx={stepOneStyles.footerImage}
                />
              </Box>
            </Box>
          </Box>
        </Paper>
    </Box>
  );
}